<template>
  <div>
    <div class="card card-header list-group-item list-group-item-action active mb-3">
      <h4 class="mb-0">Cadastro da edificação</h4>
    </div>
        <ul
      class="process-steps row ui-tabs-nav ui-corner-all ui-helper-reset ui-helper-clearfix ui-widget-header"
      role="tablist"
    >
      <li
        class="col ui-tabs-tab ui-corner-top ui-state-default ui-tab"
        :class="{'ui-tabs-active ui-state-active' : etapa == 'Edificacao'}"
        role="tab"
        tabindex="0"
        aria-controls="ptab1"
        aria-labelledby="ui-id-1"
        aria-selected="true"
        aria-expanded="true"
      >
        <a
          @click.prevent="fnEtapa('Edificacao')"
          class="i-circled i-bordered i-alt mx-auto ui-tabs-anchor"
          role="presentation"
          tabindex="-1"
          id="ui-id-1"
        >1</a>
        <h5>Dados da edificação</h5>
      </li>
      <li
        class="col ui-tabs-tab ui-corner-top ui-state-default ui-tab"
        :class="{'ui-tabs-active ui-state-active' : etapa == 'Administracao'}"
        role="tab"
        tabindex="-1"
        aria-controls="ptab2"
        aria-labelledby="ui-id-2"
        aria-selected="false"
        aria-expanded="false"
      >
        <a
          @click.prevent="fnEtapa('Administracao')"
          class="i-circled i-bordered i-alt mx-auto ui-tabs-anchor"
          role="presentation"
          tabindex="-1"
          id="ui-id-2"
        >2</a>
        <h5>Setores Administrativos</h5>
      </li>
      <li
        class="col ui-tabs-tab ui-corner-top ui-state-default ui-tab"
        :class="{'ui-tabs-active ui-state-active' : etapa == 'Operacional'}"
        role="tab"
        tabindex="-1"
        aria-controls="ptab2"
        aria-labelledby="ui-id-2"
        aria-selected="false"
        aria-expanded="false"
      >
        <a
          @click.prevent="fnEtapa('Operacional')"
          class="i-circled i-bordered i-alt mx-auto ui-tabs-anchor"
          role="presentation"
          tabindex="-1"
          id="ui-id-3"
        >3</a>
        <h5>Setores Operacionais</h5>
      </li>
    </ul>
    <div class="card">
      <form style="padding:15px;" class="formreadonly" v-if="etapa =='Edificacao'" autocomplete="off"> 
        <h4 class="mb-3">Dados da edificação</h4>
        <div class="form-row">
          <div class="form-group col-md-12">
             <label for="_form-endereco">Endereço físico - Sede </label>
             <p class="help small mb-0">Se difirente do endereço da empresa</p>
            <input
              type="text"
              class="form-control"
              v-model="cadastro.logradouro"
              id="_form-Logradouro"
              required
              maxlength="100"
            />
          </div>
          <div class="form-group col-md-4">
            <label for="_form-Tipo">Tipo</label>
            <input
              type="text"
              class="form-control"
              v-model="cadastro.tipo"
              id="_form-Tipo"
              maxlength="100"
            />
          </div>
          <div class="form-group col-md-4">
            <label for="_form-Quadra">Quadra</label>
            <input
              type="text"
              class="form-control"
              v-model="cadastro.quadra"
              id="_form-Quadra"
              maxlength="100"
            />
          </div>
          <div class="form-group col-md-4">
            <label for="_form-Bloco">Bloco</label>
            <input
              type="text"
              class="form-control"
              v-model="cadastro.bloco"
              id="_form-Bloco"
              maxlength="100"
            />
          </div>
          <div class="form-group col-md-4">
            <label for="_form-Lote">Lote</label>
            <input
              type="text"
              class="form-control"
              v-model="cadastro.lote"
              id="_form-Lote"
              maxlength="100"
            />
          </div>
          <div class="form-group col-md-4">
            <label for="_form-Numero">Número</label>
            <input
              type="text"
              class="form-control"
              v-model="cadastro.numero"
              id="_form-Numero"
              maxlength="10"
              required
            />
          </div>
          <div class="form-group col-md-4">
            <label for="_form-Complemento">Complemento</label>
            <input
              type="text"
              class="form-control"
              v-model="cadastro.complemento"
              id="_form-Complemento"
              maxlength="50"
            />
          </div>
          <div class="form-group col-md-2">
            <label for="_form-CEP">CEP</label>
            <input
              type="text"
              class="form-control"
              v-model="cadastro.cep"
              id="_form-CEP"
              maxlength="8"
              required
            />
          </div>
          <div class="form-group col-md-4">
            <label for="_form-Bairro">Bairro</label>
            <input
              type="text"
              class="form-control"
              v-model="cadastro.bairro"
              id="_form-Bairro"
              maxlength="50"
              required
            />
          </div>
          <div class="form-group col-md-4">
            <label for="_form-Cidade">Cidade</label>
            <input
              type="text"
              class="form-control"
              v-model="cadastro.cidade"
              id="_form-Cidade"
              maxlength="100"
              required
            />
          </div>
          <div class="form-group col-md-2">
            <label for="_form-UF">UF</label>
            <input
              type="text"
              class="form-control"
              v-model="cadastro.estado"
              id="_form-UF"
              maxlength="2"
              required
            />
          </div>
          <div class="form-group col-md-12">
            <label for="_form-link">Link Google Maps</label>
            <textarea class="form-control" id="_form-link" v-model="cadastro.linkGoogleMaps"></textarea>
          </div>
         <div class="col-md-2 form-group">
          <label>Sede alugada:</label>
          <div class="btn-group btn-group-toggle d-flex" data-toggle="buttons">
            <label
              class="btn btn-outline-secondary ls0 nott"
              id="ativo"
              :class="{'active': cadastro.sedeAlugada == true}"
            >
              <input type="radio" name="ativo" id="ativo"  autocomplete="off" class="valid" /> Sim
            </label>
            <label
              class="btn btn-outline-secondary ls0 nott"
              id="inativo"
              :class="{'active': cadastro.sedeAlugada == false}"
            >
              <input type="radio" name="ativo" id="inativo"    autocomplete="off" class="valid" /> Não
            </label>
          </div>
        </div>
          <div class="form-group col-md-10">
            <label for="_form-proprietario">Nome do proprietário</label>
            <input
              type="text"
              class="form-control"
              v-model="cadastro.proprietario"
              id="_form-proprietario"
              maxlength="99"
              required
            />
          </div>
         <div class="col-md-3 form-group">
          <label>Contrato comodato:</label>
          <div class="btn-group btn-group-toggle d-flex" data-toggle="buttons">
            <label
              class="btn btn-outline-secondary ls0 nott"
              id="ativo"
              :class="{'active': cadastro.contratoComodato == true}"
            >
              <input type="radio" name="ativo" id="ativo"    autocomplete="off" class="valid" /> Sim
            </label>
            <label
              class="btn btn-outline-secondary ls0 nott"
              id="inativo"
              :class="{'active': cadastro.contratoComodato == false}"
            >
              <input type="radio" name="ativo" id="inativo"    autocomplete="off" class="valid" /> Não
            </label>
          </div>
        </div>

        <div class="form-group col-md-4">
           <label for="_form-mercadoImovel">Valor do mercado do imóvel</label>
           <vue-numeric
              v-bind:precision="2"
              type="text"
              class="form-control"
              v-model="cadastro.valorMercadoImovel"
              id="_form-mercadoImovel"
              required
              separator="."
              currency="R$"
           />

          </div>
           <div class="form-group col-md-5">
           <label for="_form-iAluguel">Valor do mercado do aluguel do imóvel</label>
           <vue-numeric
              v-bind:precision="2"
              type="text"
              class="form-control"
              v-model="cadastro.valorMercadoImovelAluguel"
              id="_form-iAluguel"
              required
              separator="."
              currency="R$"
           />

          </div>
           <div class="form-group col-md-3">
           <label for="_form-valorCondominio">Valor do condomínio</label>
           <vue-numeric
              v-bind:precision="2"
              type="text"
              class="form-control"
              v-model="cadastro.valorCondominio"
              id="_form-valorCondominio"
              required
              separator="."
              currency="R$"
           />

          </div>
          <div class="col-sm-12 form-group ">&nbsp;ssssss</div>
           <div class="form-group col-md-4">
            <label for="_form-vAluguel">Valor do aluguel (se pago)</label>
            <vue-numeric
                v-bind:precision="2"
                type="text"
                class="form-control"
                v-model="cadastro.valorAluguel"
                id="_form-vAluguel"
                required
                separator="."
                currency="R$"
            />

          </div>
           <div class="form-group col-md-4">
           <label for="_form-areaTerreno">Area do terreno do imóvel</label>
           <vue-numeric
              v-bind:precision="2"
              type="text"
              class="form-control"
              v-model="cadastro.areaTerreno"
              id="_form-areaTerreno"
              required
              separator="."
           />
          </div>
           <div class="form-group col-md-4">
           <label for="_form-areaConstruida">Área construida do imóvel</label>
           <vue-numeric
              v-bind:precision="2"
              type="text"
              class="form-control"
              v-model="cadastro.areaContruida"
              id="_form-areaConstruida"
              required
              separator="."
           />

          </div>
           <div class="form-group col-md-4">
           <label for="_form-areaUtil">Área útil total do imóvel</label>
           <vue-numeric
              v-bind:precision="2"
              type="text"
              class="form-control"
              v-model="cadastro.areaUtil"
              id="_form-areaUtil"
              required
              separator="."
           />

          </div>
          <div class="col-sm-12"></div>
        </div>
        <div style="padding:15px;">
          <div class="row">
              <div class="col-sm-4" v-if="cadastro.foto1"><img :src="cadastro.foto1" class="img-fluid"></div>
              <div class="col-sm-4" v-if="cadastro.foto2"><img :src="cadastro.foto2" class="img-fluid"></div>
              <div class="col-sm-4" v-if="cadastro.foto3"><img :src="cadastro.foto3" class="img-fluid"></div>
          </div>
        </div>


      </form>
      <form style="padding:15px;margin-bottom:30px;" v-show="etapa == 'Administracao'" >

        <div class="row" v-show="filterAdministracoes">
            <h4 class="col-sm-12">Setores cadastrados</h4>
           <div class="col-md-6"  v-for="(item, i) in filterAdministracoes" :key="i" style="margin-bottom:30px;">
                <div class="card">
                    <div class="card-header">{{fnConcat(item.setorId)}}</div>
                    <div class="card-body">
                        <p class="card-text">
                            <span>
                                Área:
                            <b>
                                <i>{{item.area}}</i>
                            </b>
                            </span>
                            <br />
                        </p>
                        <p class="card-text mb-1">
                            <span>
                                Compartilha setor: 
                            <b>
                                <i>{{fnConcatSetorA(item.setorDivideEspacoId)}}</i>
                            </b>
                            </span>
                            <br />
                        </p>
                        <div style="padding:15px;">
                          <div class="row">
                            <div class="col-sm-4" v-if="item.foto1"><img :src="item.foto1" class="img-fluid"></div>
                            <div class="col-sm-4" v-if="item.foto2"><img :src="item.foto2" class="img-fluid"></div>
                            <div class="col-sm-4" v-if="item.foto3"><img :src="item.foto3" class="img-fluid"></div>
                          </div>

                      </div>
                  </div>
              </div>
          </div>
        </div>

      </form>      
      <form style="padding:15px;margin-bottom:30px;" v-show="etapa == 'Operacional'" >
        <div class="row" v-show="filterOperacionais">
            <h4 class="col-sm-12">Setores cadastrados</h4>
           <div class="col-md-6"  v-for="(item, i) in filterOperacionais" :key="i" style="margin-bottom:30px;">
                <div class="card">
                    <div class="card-header">{{fnConcatOp(item.setorId)}}</div>
                    <div class="card-body">
                        <p class="card-text mb-1">
                            <span>
                                Área:
                            <b>
                                <i>{{item.area}}</i>
                            </b>
                            </span>
                            <br />
                        </p>
                        <p class="card-text mb-1">
                            <span>
                                Qtde. veículos no setor:
                            <b>
                                <i>{{item.qtdeVagasSetor}}</i>
                            </b>
                            </span>
                            <br />
                        </p>
                        <p class="card-text mb-1">
                            <span>
                                Qtde. vagas estacionamento:
                            <b>
                                <i>{{item.qtdeVagasEstacionamento}}</i>
                            </b>
                            </span>
                            <br />
                        </p>
                        <p class="card-text mb-1">
                            <span>
                                Qtde. vagas de transição:
                            <b>
                                <i>{{item.qtdeVagasTransicao}}</i>
                            </b>
                            </span>
                            <br />
                        </p>
                        <p class="card-text mb-1">
                            <span>
                                Qtde. total de veículos em serviço:
                            <b>
                                <i>{{item.qtdeVeiculosServico}}</i>
                            </b>
                            </span>
                            <br />
                        </p>
                        <p class="card-text mb-1">
                            <span>
                                Quarda veículos:
                            <b>
                                <i :class="item.guardaVeiculos ? 'icon-checkbox-checked':'icon-times-circle1'"></i>
                            </b>
                            </span>
                            <br />
                        </p>
                        <p class="card-text mb-1">
                            <span>
                                Compartilha setor: 
                            <b>
                                <i>{{fnConcatSetor(item.setorDivideEspacoId)}}</i>
                            </b>
                            </span>
                            <br />
                        </p>
                         <div style="padding:15px;">
                          <div class="row">
                            <div class="col-sm-4" v-if="item.foto1"><img :src="item.foto1" class="img-fluid"></div>
                            <div class="col-sm-4" v-if="item.foto2"><img :src="item.foto2" class="img-fluid"></div>
                            <div class="col-sm-4" v-if="item.foto3"><img :src="item.foto3" class="img-fluid"></div>
                          </div>

                      </div>
                       
                    </div>
                </div>
            </div>
        </div>
      </form>      
    </div>
  </div>
</template>

<script>
import { getSuccess,clientKey } from "../../../../global/utils";

export default {
  data() {
    return {
      cadastro: {
        sedeAlugada:false,
        contratoComodato:false,
        contratacaoId: null
      },
      administracoes:[],
      setoresadministracoes:{

      },
      setoresoperacionais:{
      },
      setoresE03A:[],
      operacionais:[],
      administracao:{
          guardaVeiculos:false,
          etapaId:null,
          administrativo:true,
      },
      operacional:{
         etapaId:null,
         guardaVeiculos:false,
        administrativo:false,

     },
      cadastroId: null,
      contrato:{},
      etapa: 'Edificacao'
    }
  },
  mounted() {
    //this.fnGetPorte()
    this.fnGetOperacional()
    this.fnGetAdministracao()
    this.fnGetContratacao()
  },
 methods: {
   mudaSede(val){
      if(this.cadastro.sedeAlugada != val ){this.cadastro.sedeAlugada =!this.cadastro.sedeAlugada}
   },
   mudaGuardaVeiculos(val){
      if(this.operacional.guardaVeiculos != val ){this.operacional.guardaVeiculos =!this.operacional.guardaVeiculos}
   },
   mudaContrato(val){
      if(this.cadastro.contratoComodato != val ){this.cadastro.contratoComodato =!this.cadastro.contratoComodato}
   },
   async fnGetContratacao() {
    await this.$http
      .get(`contratacao/codigo/${this.$route.params.codigoContrato}/etapa_03`)
      .then((res) => {
        this.cadastro.contratacaoId = res.data.contratacaoId;
        this.cadastroId = res.data.contratacaoId;
        if(res.data.contratacoesEVO03 != null){
          this.cadastro = res.data.contratacoesEVO03
        }
        if(res.data.contratacoesEVO03.contratacoesEVO03A != null){
          let itemAdmin = res.data.contratacoesEVO03.contratacoesEVO03A
          this.setoresE03A = itemAdmin
        }
      })
      .catch(() => {});
  },
 
   async fnGetAdministracao(){
      await this.$http.get('listasetores/api/administracao')
      .then(res=> {
        this.setoresadministracoes = res.data
      })
      .catch(()=>{})
   },
   async fnGetOperacional(){
      await this.$http.get('listasetores/api/operacional')
      .then(res=> {
        this.setoresoperacionais = res.data
      })
      .catch(()=>{})
   },

   async fnCadastra(e) {
     e.preventDefault();
     const metodo = this.cadastro.etapaId ? "put" : "post";
     this.cadastro.tsAlteracao = this.cadastro.etapaId
       ? this.$moment().format()
       : null;
     const completaUrl = this.cadastro.etapaId
       ? "/" + this.cadastro.etapaId
       : "";
     await this.$http[metodo]("/etapa_03" + completaUrl, this.cadastro)
       .then((res) => {
         if ( metodo == "post"){this.cadastro = res.data} 
         getSuccess();
       })
       .catch(() => {});
   },    
    fnEtapa(val) {
      if (this.cadastro.etapaId == undefined) {
        if (val == "Administracao" || val == "Operacional" ) {
          this.$toasted.global.defaultInfo({
            msg: "Finalize os dados das obrigações.",
          });
        }
      } else {
        this.etapa = val;
      }
    },
   async fnCadastraAdministracao(e) {
     e.preventDefault();
     const metodo = this.administracao.etapaAid ? "put" : "post";
     this.administracao.tsAlteracao = this.administracao.etapaAid
       ? this.$moment().format()
       : null;
     const completaUrl = this.administracao.etapaAid ? "/" + this.administracao.etapaAid : "/" + this.cadastroId;
     this.administracao.etapaId = this.cadastro.etapaId
     this.administracao.administrativo = true
     await this.$http[metodo]("/etapa_03A" + completaUrl, this.administracao)
       .then((res) => {
         if ( metodo == "post"){this.filterAdministracoes.push(res.data)} 
         this.administracao = {
             qtdeVeiculosServicos: null,
             qtdeVagasEstacionamento: null,
             qtdeVagasTransicao: null,
             guardaVeiculos: false,
             administrativo: true,
             etapaId: this.cadastro.etapaId
         }
         getSuccess();
       })
       .catch(() => {});
   },   
   async fnCadastraOp(e) {
     e.preventDefault();
     const metodo = this.operacional.etapaAid ? "put" : "post";
     this.operacional.tsAlteracao = this.operacional.etapaAid
       ? this.$moment().format()
       : null;
     const completaUrl = this.operacional.etapaAid ? "/" + this.operacional.etapaAid :  "/" + this.cadastroId;
     this.operacional.etapaId = this.cadastro.etapaId
     this.operacional.administrativo = false
     await this.$http[metodo]("/etapa_03A" + completaUrl, this.operacional)
       .then((res) => {
         if ( metodo == "post"){this.filterOperacionais.push(res.data)} 
         this.operacional = {
             qtdeVeiculosServicos: 0,
             qtdeVagasEstacionamento: 0,
             qtdeVagasTransicao: 0,
             guardaVeiculos: false,
             administrativo: false,
             etapaId: this.cadastro.etapaId
         }
         getSuccess();
       })
       .catch(() => {});
   },
   fnEditar(i){
       this.administracao = this.filterAdministracoes[i]
   },
   fnEditarOp(i){
       this.operacional = this.filterOperacionais[i]
   },
   fnConcat(val){
    var item = this.setoresadministracoes.filter((administracoes) => {
       return administracoes.setorId ==val
     });
       var toString = JSON.stringify(item)
       var toJson = JSON.parse(toString)
       return toJson[0].titulo
   },
   fnConcatOp(val){
    var item = this.setoresoperacionais.filter((administracoes) => {
       return administracoes.setorId ==val
     });
       var toString = JSON.stringify(item)
       var toJson = JSON.parse(toString)
       return toJson[0].titulo
   },
   fnConcatSetor(val){
    var item = this.filterOperacionais.filter((administracoes) => {
       return administracoes.etapaAid ==val
     });
      if(item.length >0){
       var toString = JSON.stringify(item)
       var toJson = JSON.parse(toString)
       return  this.fnConcatOp(toJson[0].setorId)
     }
       
   },
   fnConcatSetorA(val){
     console.log(val)
     if(val != '' && val != undefined)
     {

    var item = this.filterAdministracoes.filter((administracoes) => {
       return administracoes.etapaAid ==val
     });
      if(item.length >0){
       var toString = JSON.stringify(item)
       var toJson = JSON.parse(toString)
       return  this.fnConcat(toJson[0].setorId)

      }
     }
       
   },
   fnVerificaAdminsitracao(val){
      var item = this.setoresadministracoes.filter((administracoes) => {
       return administracoes.setorId === val
     });
     if (item.length > 0){
       return true
     }else{
       return false
     }
   },
        convertToken(token) {
        var base64Url = token.split('.')[1];
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        var jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
    
        return JSON.parse(jsonPayload);
        },
    async fnDeletar(val) {

        var token = localStorage.getItem(clientKey)
        var dataToken = this.convertToken(token)
      await this.$http.delete(`/etapa_03A/${val}/${dataToken.ClienteId}/${this.cadastroId}`)
        .then(() => {
          let i = this.filterAdministracoes.map(item => item.etapaAid).indexOf(val) 
          this.filterAdministracoes.splice(i, 1)
          this.fnGetContratacao()
          getSuccess();
        })
        .catch(() => {});
    },
    async fnDeletarB(val) {

        var token = localStorage.getItem(clientKey)
        var dataToken = this.convertToken(token)
      await this.$http.delete(`/etapa_03A/${val}/${dataToken.ClienteId}/${this.cadastroId}`)
        .then(() => {
          let i = this.filterOperacionais.map(item => item.etapaAid).indexOf(val) 
          this.filterOperacionais.splice(i, 1)
          this.fnGetContratacao()
          getSuccess();
        })
        .catch(() => {});
    }

},
computed: {
  filterOperacionais: function(){
     let data = [];
      for (var i = 0 ; i < this.setoresE03A.length; i++)
      {
        var admin = this.fnVerificaAdminsitracao(this.setoresE03A[i].setorId)
        if(!admin){
              data.push(this.setoresE03A[i])
        }
      
      }
    return data
  },
  filterAdministracoes: function(){
     let data = [];
      for (var i = 0 ; i < this.setoresE03A.length; i++)
      {
        var admin = this.fnVerificaAdminsitracao(this.setoresE03A[i].setorId)
        if(admin){
              data.push(this.setoresE03A[i])
        }
      
      }
    return data
  }
},
};
</script>

<style lang="scss" scoped>
.card-header {
  h4 {
    color: #fff;
    text-align: center;
  }
}

</style>